import _, { isNull } from "lodash";
import searchLogo from "../assets/images/searchLogo.svg";
import editIcon from '../assets/images/editIcon.png';
import { status } from "./constants";
import { validateDiv, validateTermDate } from "./tradeValidations";
import moment from "moment";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";

function isFloat(n:any){
  return Number(n) === n && n % 1 !== 0;
}

const markFormatter = (p: any) => {
  let mark:any;
  if (p?.value && !isNaN(p?.value) && _.isString(p.value)) {
   return parseInt(p.value);
  }
  else if (_.isNumber(p?.value)) {
   return p?.value;
  } else if(!/[0-9]/gm.test(p?.value)){
    return '';
  }
  if(mark){
    return Math.trunc(mark);
  }
  return p?.value;
}

export const ContractUpdateColDefs = [

  {
    headerName: "Contract Id",
    field: "contract_id",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "contract_type",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 60,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    filter: "agTextColumnFilter",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Name",
    field: "cpty_name",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 170,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    width: 65,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    minWidth: 85,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Security Name",
    field: "secMaster_name",
    floatingFilter: false,
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 200,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Mark",
    field: "collMgn",
    type: "rightAligned",
    floatingFilter: false,
    editable: true,
    filter: "agNumberColumnFilter",
    valueFormatter: markFormatter,
    
    cellEditorParams: {
      maxLength: 3
  },
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="me-1" height="14px" width="14px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
</div>`
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if(!params.node.data.isTotalRow && (!params?.node?.data?.collMgn || isNull(params?.node?.data?.collMgn)) ){
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      }
     else if (!params.node.data.isTotalRow && params?.node?.data?.collMgn && (params?.node?.data?.collMgn <= 0 || isFloat(params?.node?.data?.collMgn) ||
        params?.node?.data?.collMgn>999)) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else if(( params?.node?.data?.collMgn >0 && (params?.node?.data?.collMgn < 95 || params?.node?.data?.collMgn > 106))){
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.warning,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 80,
    maxWidth: 110,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Div",
    field: "div",
    floatingFilter: false,
    type: "rightAligned",
    valueFormatter: markFormatter,
    editable: true,
      headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="me-1" height="14px" width="14px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
        </div>`
    },
    cellEditorParams: {
      maxLength: 3
  },
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    function (params: any) {
      if (!params.node.data.isTotalRow && (!validateDiv(params.node.data.div) || !params.node.data.div)) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
          justifyContent: "flex-end",
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          justifyContent: "flex-end",
        };
      }
    },
    minWidth: 80,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Term Date",
    field: "term_date",
    floatingFilter: false,
    editable: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    tooltipField: "term_date",
    
    tooltipComponentParams: function (params: any) {
      let CurrentDate = new Date();
      let CurrentDateLength = moment(CurrentDate).format("MM/DD/YYYY");
      if (params.node.data.term_date < CurrentDateLength) {
        return { message: "Invalid Term Date" };
      }
    },
    cellStyle: function (params: any) {
      let localTermDate = moment(params.node.data.term_date);

      if (
        params.node.data.term_date === "-" ||
        params.node.data.term_date === undefined ||
        params.node.data.term_date === null ||
        params.node.data.term_date === ""
      ) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      } else if (!localTermDate.isValid() || !validateTermDate(params.node.data.term_date)) {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.error,
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
    headerComponentParams: {
      template: `
      <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        <img class="me-1" height="14px" width="14px" src="${editIcon}" /> 
        <span ref="eText" class="ag-header-cell-text"></span>
        <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order" aria-hidden="true"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" aria-hidden="true"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" aria-hidden="true"></span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon" aria-hidden="true"></span>
    </div>
        </div>`
    },
    minWidth: 90,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
 
];